import { Modal } from 'antd';

interface IProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const ModalConfirm = ({ open, onCancel, onConfirm, loading }: IProps) => {
  return (
    <Modal
      open={open}
      closable={false}
      cancelText='Fechar'
      onCancel={onCancel}
      okText='Desativar página'
      onOk={onConfirm}
      confirmLoading={loading}
    >
      <p>
        Ao desativar, sua Página de vendas será desativada e a URL passará a ficar disponível para uso por outras
        contas. Continuar?
      </p>
    </Modal>
  );
};
